// common.js

import {
    axios,
    useImperativeHandle, forwardRef, useRef, useContext, useState, useEffect,
    useSelector, useDispatch,
    useLocation, useNavigate, Link,
    AppTheme,
    mui, reducer, component, useShared,  
    VERSION, COUNTRY_LIST, MAX_LENGTH_SEARCH_STRING, MAX_LENGTH_NOTE_CONTENT, MAX_LENGTH_NOTE_TITLE, SPACE, API_BASE_URL, MAX_LENGTH_NON_SEARCH_STRING1, MAX_LENGTH_NON_SEARCH_STRING2,
    homeContext, searchContext, noteContext,
} from '../Utilities/sharedHeader';

const { Slider, Snackbar, styled, grey, Grid, Chip, Divider, Tab, Tabs, Box, Accordion, AccordionSummary, AccordionDetails, ListItemIcon, List, ListItem, ListItemText, TextField, IconButton, InputBase, Paper, Alert, Select, FormControl, FormControlLabel, FormLabel, FormGroup, MenuItem, Container, Typography, ButtonGroup, Button, Stack, Fab, CircularProgress, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Radio, RadioGroup, AppBar, Toolbar, Table, TableContainer, TableBody, TableRow, TableCell, CardMedia, CardContent, CssBaseline, FormHelperText, Switch, Card, CheckIcon, ClearIcon, DeleteIcon, CloseIcon, ExpandMoreIcon, VisibilityOutlinedIcon, KeyboardArrowUpIcon, KeyboardDoubleArrowUpIcon, HistoryIcon, StickyNote2Icon, NoteAddIcon, SearchIcon, DescriptionIcon, EditDocumentIcon, ImportContactsIcon, WestIcon, EastIcon, HomeIcon, PersonIcon, LogoutIcon, PlagiarismIcon, DeviceThermostatIcon, FileCopyIcon, LocalOfferIcon, InfoIcon } = mui;
const { setButtonTextDialog4, setButtonText, setDialogTitle, setBookReadLogToBeCleared, setCallerConfirmationDialog, setCaller4NoteBookmarkList, setNoteSearchString, setConfirmedNoteSearchString, setNoteSearchStringClearButton, setShowRemainingNoteSearch, setSearchCriteriaListItem2, setSearchResultVerseList2, setPageNumberNoteSearch, setVerseListItem2, setNoteSearchStringPlaceHolder, reset4NoteSearch, setTabVerseListNew, reset4SignIn, setTitleToBeDeleted, reset4ConfirmationDialog, reset4GoToTopButtonVisible, reset4NoteBookmarkList, reset4Dialog4, reset4NoteBookmarkVerseList, reset4ChipArray, reset4verseLabelArrows4Result, reset4Switch1, reset4Dialog2, reset4Search, reset4Verse, reset4Chapter, reset4Book, reset4Home, setGoToTopButtonVisible, setVerseListItem, setNonSearchString1PlaceHolder, setNonSearchString2PlaceHolder, setSearchStringPlaceHolder, setSearchString, setShowLeftArrowVerseSearch, setShowRightArrowVerseSearch, setShowfabContentVerseSearch, setShowLeftArrowNote, setShowRightArrowNote, setShowfabContentNote, setShowLeftArrowNoteSearch, setShowRightArrowNoteSearch, setShowfabContentNoteSearch, setSearchCriteriaListItem, setPageNumberVerseSearch, setOpenConfirmationDialog, setOpen3, setConfirmedTabNumber, setOpen2, setPageNumberNote, setDetails, setLengthIndicator4Details, setLengthIndicator4Title, setLoading, setHistoryList, setHistoryListItemSelected, setHistoryBookChapter, setNoteBookmarkList, setNoteBookmarkListBookChapterVerse, setConfirmedSearchString, setNonSearchString1, setNonSearchString2, setSearchStringClearButton, setNonSearchStringClearButton, setSearchScopeList, setSearchScopeListItemSelected, setChipData, setShowRemaining, setSearchResultVerseList, setSearchHttpPostData, setBookChapterList, setBookChapterListItemSelected, setOpen1, setBookListItemSelected, setSearchCriteria, setLoading4Home, setUserListItem, setVerseReadLogList4Book, setSearchTabNumber, setBookChapter, setBookList, setTitle, setTitleClearButton, setBook4Accordion1, setChapter4Accordion1, setVerse4Accordion1, setBookChapter2, setBookChapterList2, setVerseList4Accordion1, setNoteBookmarkVerseList, setNoteBookmarkListItemToBeDeleted, setNoteBookmarkListItemToBeChanged, setTab4AddChange, setViewArea, setCredential, setCircularProgressText, setEmailExisted, setUsernameExisted, setLastNameOverMaxLength, setFirstNameOverMaxLength, reset4Profile } = reducer;
const { SignUpEmailSent, Profile4System, Profile4Personal, History, AddChangeNote, FullFormatVerse, Book, Stack1, NoteVerseList, Chapter, Dialog1, Dialog2, Dialog3, Dialog4, Tab1, Navbar, VerseSearch, Verse, NoteBookmarkList, NoteBookmarkListItem, VerseLabelArrows4Result, ConfirmationDialog, Accordion1, ChipArray, SearchResult, ForgotPassword, ClipLoader1, VerseLabelArrows, Switch1, Selection, Profile, UserListItem } = component;  

export function maskedEmail(email) {
  const [part1, part2] = email.split('@');
  const part1FirstChar = part1[0]; // First character
  const part1LastChar = part1[part1.length - 1]; // Last character
  const maskedPart1 = part1FirstChar + '******' + part1LastChar;
  return `${maskedPart1}@${part2}`;
}

export function getYearOfBirthList(currentYear) {
  const startYear = currentYear - 100 + 1; // Calculate the starting year
  const yearOfBirthList = [];

  for (let yearOfBirth = startYear; yearOfBirth <= currentYear; yearOfBirth++) {
    yearOfBirthList.push(yearOfBirth); // Add each year to the list
  }

  return yearOfBirthList;
}

export function setRead(tabVerseListNew, book, chapter, read) {
  const updatedTabVerseListNew = tabVerseListNew.map((item) =>
    item.book === book && item.chapter === chapter ? { ...item, read: read } : item
  );
  return updatedTabVerseListNew;
}

export function resetSelectedAll(tabVerseListNew) {
  let list = tabVerseListNew;
  for (let tabNumber = 0; tabNumber < 4; tabNumber++) {
    let tabVerseListNewItem = tabVerseListNew[tabNumber];
    const updatedTabVerseListNewItem = resetSelected(tabVerseListNewItem);
    list = replaceTabVerseListNewItem(list, tabNumber, updatedTabVerseListNewItem);
  };
  return list;
}

export function resetSelected(tabVerseListNewItem) {
  const updatedTabVerseListNewItem = {
    ...tabVerseListNewItem,
    verses: tabVerseListNewItem.verses.map(item => ({
      ...item,
      selected: false
    }))
  }
  return updatedTabVerseListNewItem;
}

export function resetHasNote(tabVerseListNewItem) {
    const updatedTabVerseListNewItem = {
      ...tabVerseListNewItem,
      verses: tabVerseListNewItem.verses.map(item => ({
        ...item,
        hasNote: false
      }))
    }
    return updatedTabVerseListNewItem;
}

export function verseList2verseListNew(details) {
  const list = details.map(detailsItem => ({
    details: detailsItem,
    hasNote: false,
    selected: false,
  }));
  return list; // Make sure to return the list
}

export function verseRangeChineseName(bookList, verseRange) {
  if (verseRange.verseStart === verseRange.verseEnd) {
    return `${bookList[verseRange.book-1].Chinese_Code} ${verseRange.chapter}:${verseRange.verseStart}`
  } else {
    return `${bookList[verseRange.book-1].Chinese_Code} ${verseRange.chapter}:${verseRange.verseStart}-${verseRange.verseEnd}`
  }  
}

export function sortResultList(resultList) {
    return resultList.sort((a, b) => {
        if (a.book !== b.book) {
            return a.book - b.book; // Sort by book
        }
        if (a.chapter !== b.chapter) {
            return a.chapter - b.chapter; // Sort by chapter
        }
        return a.verse - b.verse; // Sort by verse
    });
}

export function canPushNewEntry(resultList, result) {
    return !resultList.some(resultListItem => 
        resultListItem.book === result.book && 
        resultListItem.chapter === result.chapter && 
        resultListItem.verse === result.verse
    );
}

export function circularProgressTextUpdate(functionName) {
  let date = new Date();
  return `(${functionName} ${date.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit', second: '2-digit', hour12: false })})`;
}

export function refreshHasNoteVersesDelete(hasNoteVerses, noteBookmarkVerseList) {

}

export function refreshHasNoteVersesAdd(hasNoteVerses, noteBookmarkVerseList) {
  const updatedHasNoteVerses = hasNoteVerses.map(hasNoteVersesChild => { // Find all verses in noteBookmarkVerseList that match the current book and chapter
      const matchingVerses = noteBookmarkVerseList
          .filter(noteBookmarkVerseListItem => noteBookmarkVerseListItem.book === hasNoteVersesChild.book && noteBookmarkVerseListItem.chapter === hasNoteVersesChild.chapter)
          .map(noteBookmarkVerseListItem => noteBookmarkVerseListItem.verse); // Extract the verse numbers            
      const updatedHasNote = Array.from(new Set([...hasNoteVersesChild.hasNote, ...matchingVerses])); // Combine existing hasNote values with new verses, ensuring no duplicates
      return { // Return the updated object
          ...hasNoteVersesChild,
          hasNote: updatedHasNote,
      };
  });
  return updatedHasNoteVerses;
}

export function localizedDateTime(dateString) {
  const date = new Date(dateString);
  return (
    date.toLocaleString(undefined, {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      hour12: false, // Use 24-hour format    
    })
  );
}

export function replaceHasNoteVersesChild(hasNoteVerses, whichChild, newHasNoteVersesChild) {
  const updatedHasNoteVerses = hasNoteVerses.map((currentHasNoteVersesChild, index) =>
    index === whichChild ? newHasNoteVersesChild : currentHasNoteVersesChild
  );
  return updatedHasNoteVerses;
};

export function replaceSelectedVersesChild(selectedVerses, whichChild, newSelectedVersesChild) {
  const updatedSelectedVerses = selectedVerses.map((currentSelectedVersesChild, index) =>
    index === whichChild ? newSelectedVersesChild : currentSelectedVersesChild
  );
  return updatedSelectedVerses;
};

export function replaceTabVerseListNewItem(tabVerseListNew, tabNumber, newTabVerseListNewItem) {
  const updatedTabVerseListNew = tabVerseListNew.map((currentTabVerseListNewItem, index) =>
    index === tabNumber ? newTabVerseListNewItem : currentTabVerseListNewItem
  );
  return updatedTabVerseListNew;
};

// export function replaceTabVerseListChild(tabVerseList, whichChild, newVerseListChild) {
//   const updatedTabVerseList = tabVerseList.map((currentTabVerseListChild, index) =>
//     index === whichChild ? newVerseListChild : currentTabVerseListChild
//   );
//   return updatedTabVerseList;
// };

export function Highlight2(tokens) {

  return tokens.map((token) => {
    switch(token.highlight){
      case false:
        return <Box component='span'>{token.substring}</Box>;
      case true:
        return <Box component='span' sx={{ color: 'warning.dark' }}>{token.substring}</Box>;
    }
  })

}

export function Highlight1(details, includedIndexes) {
  
  let list = includedIndexes.filter(item => item.highlight);
  
  if (list.length !== 0) {     

    let tokens = [];    

    if (list[0].indexFrom !== 0) tokens.push({substring: details.substring(0, list[0].indexFrom), highlight: false});

    for (let i = 0; i < list.length; i++) {
      tokens.push({substring: details.substring(list[i].indexFrom, list[i].indexTo + 1), highlight: true});
      if (i < list.length-1) tokens.push({substring: details.substring(list[i].indexTo + 1, list[i + 1].indexFrom), highlight: false});
    }

    if (list[list.length-1].indexTo !== details.length-1) tokens.push({substring: details.substring(list[list.length - 1].indexTo + 1, details.length), highlight: false});

    return Highlight2(tokens);

  } else {

    return <Box component='span'>{details}</Box>;

  }
}

export function Highlight(details, searchCriteria) {

  const includedIndexes = [];
  const excludedIndexes = [];

  let start1 = 0;
  while (start1 < details.length) { // Find included indexes
      start1 = details.indexOf(searchCriteria.searchString, start1);
      if (start1 === -1) break; // No more occurrences found
      includedIndexes.push({indexFrom: start1, indexTo: start1 + searchCriteria.searchString.length - 1, highlight: true});        
      start1 += searchCriteria.searchString.length;
  }
  
  for (const excludedListItem of searchCriteria.excludedList) { // Find excluded indexes
      let start2 = 0;
      while (start2 < details.length) {
          start2 = details.indexOf(excludedListItem.Value, start2);
          if (start2 === -1) break; // No more occurrences found
          excludedIndexes.push({indexFrom: start2, indexTo: start2 + excludedListItem.Value.length - 1});            
          start2 += excludedListItem.Value.length;
      }
  }
  
  for (const includedItem of includedIndexes) { // Mark included items that are overlapped by excluded items
      for (const excludedItem of excludedIndexes) {
          if (includedItem.indexFrom >= excludedItem.indexFrom && includedItem.indexTo <= excludedItem.indexTo) includedItem.highlight = false;
      }
  }
  
  return Highlight1(details, includedIndexes);
    
}

export function containExcludedListItems(details, searchCriteriaListItemRC) {
  for (const excludedListItem of searchCriteriaListItemRC.excludedList) {
      if (details.includes(excludedListItem.Value)) {
          return true;
      }
  }
  return false;
}

export function getInitialValue(getValue, defaultValue) {
  const savedValue = sessionStorage.getItem(getValue);
  return savedValue !== null ? JSON.parse(savedValue) : defaultValue;
};

export function getBookChapterVerseChineseName(bookList, book, chapter, verse, shortformat, textOnly) {
  if (book > 0 && chapter > 0 && verse > 0) {
    if (shortformat) {
      if (textOnly) {
        return `${bookList[book-1].Chinese_Code} ${chapter}:${verse}`
      } else {
        return <span>{bookList[book-1].Chinese_Code} {chapter}:{verse}</span>
      }      
    } else {
      if (textOnly) {
        return `${bookList[book-1].Chinese_Name} ${chapter}:${verse}`
      } else {
        return <span>{bookList[book-1].Chinese_Name} {chapter}:{verse}</span>
      }      
    }  
  } else {
    return null;
  }
}

export function getBookChapterChineseName(bookList, bookChapter) {
  return bookList[bookChapter.book-1].Chinese_Name + SPACE + getChapterChineseName(bookChapter)
}

export function getTabLabel(bookList, tabVerseListNew, tabNumber) {
  if (tabVerseListNew[tabNumber].book > 0 && tabVerseListNew[tabNumber].chapter > 0) {
    return <span>{bookList[tabVerseListNew[tabNumber].book-1].Chinese_Code} {tabVerseListNew[tabNumber].chapter}</span>
  } else {
    return <span style={{ display: 'flex', alignItems: 'center', gap: 5 }}><ImportContactsIcon />{tabNumber+1}</span>
  };
}

export function getChapterChineseName({book, chapter}) {
      
  let char;
      
  if (book === 19) {
    char = '篇';
  } else {
    char = '章';
  }

  return ('第' + SPACE + chapter + SPACE + char);

}